import pkginfo from './pkginfo.json';

export const VERSION = pkginfo.version;
